import {Application} from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export {application}

Turbo.StreamActions.scroll_to = function () {
    const target = this.targetElements[0];
    target.scrollIntoView({behavior: "smooth"});
};